/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Gets message text ""
 * 
 * @param {boolean} hasTechnicalDetails - Whether technical details exist
 * @param {boolean} isMobile - Whether on mobile device
 * @returns {object} Style object
 */
export function getMessageTextStyles(hasTechnicalDetails: boolean, isMobile: boolean) {
  return {
    fontFamily: 'var(--font-family)',
    color: 'var(--text-primary)',
    fontSize: isMobile ? '0.9rem' : '0.875rem',
    lineHeight: 1.5,
    margin: 0,
    padding: 0,
    width: '100%',
  };
}

